var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97581 20.3007C10.9004 20.9512 12.5174 21.9508 12.5859 21.9933C12.7856 22.1168 13.0413 22.1845 13.3052 22.1845C13.5697 22.1845 13.8251 22.1168 14.0235 21.9933C14.0919 21.9508 15.7093 20.9512 16.6342 20.3007C23.4847 15.4856 26.7139 9.88961 25.2724 5.33218C24.4529 2.7408 22.1715 1 19.5955 1C17.9582 1 16.3068 1.6332 15.0643 2.73687C14.1247 3.57141 13.4885 4.8915 13.3055 5.30239C13.1388 4.92882 12.4981 3.58287 11.546 2.73687C10.3032 1.63287 8.65115 1 7.01414 1C4.43847 1 2.15713 2.7408 1.33765 5.33185C-0.103904 9.88929 3.12526 15.4856 9.97581 20.3007ZM2.33098 5.64583C3.01263 3.49022 4.89454 2.04179 7.01414 2.04179C8.39937 2.04179 9.79935 2.57906 10.8542 3.51576C11.7605 4.32084 12.375 5.77352 12.3753 5.77352C12.6402 6.51705 13.0714 6.62804 13.3052 6.62804C13.5389 6.62804 13.9701 6.51672 14.2248 5.79873C14.2314 5.78399 14.8462 4.32378 15.7567 3.51576C16.811 2.57906 18.2103 2.04179 19.5959 2.04179C21.7155 2.04179 23.5977 3.49022 24.2793 5.64616C25.5768 9.74817 22.495 14.9074 16.035 19.4481C15.136 20.0803 13.4928 21.0962 13.4761 21.1067C13.4548 21.1205 13.3949 21.1427 13.3055 21.1427C13.2161 21.1427 13.1555 21.1198 13.1339 21.1067C13.1176 21.0962 11.475 20.0806 10.5756 19.4481C4.11565 14.9077 1.03382 9.74785 2.33098 5.64583Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.3414b171969479459845056a5200e5ea.svg";
export { ForwardRef as ReactComponent };